module.exports = __webpack_public_path__ + "static/img/chazhao.e58ecab5.svg";